import React from "react";
import ParentNavBar from "./Navbar/ParenComponent.js";
import Footer from "./Footer/Footer.js";
import "./home.css";
import GradientWrapper from "./GradientWrapper/GradientWrapper.js";
import {
  Card,
  CardContent,
  Typography,
  Button,
  CardMedia,
  Grid,
  Box,
  ListItemText,
  ListItem,
  Divider,
  List,
  Link,
} from "@mui/material";

const Testimonials = () => {
  return (
    <>
      <GradientWrapper>
        <ParentNavBar />
        <div style={{ height: 100 }}></div>

        <Box
          sx={{
            // paddingBottom: 5,
            paddingX: 2,
            backgroundColor: "#fff",
          }}
        >
          <Grid
            container
            // justifyContent="center"
            flexDirection={"column"}
            alignItems={"center"}
          >
            <Typography
              variant="h4"
              component="div"
              sx={{
                marginBottom: 2,
                maxWidth: 800,
                marginLeft: "auto",
                marginRight: "auto",
                width: "100%",
                fontSize: "1.7em",
                fontWeight: "bold",
                color: "#555",
              }}
              fontFamily={"Montserrat, sans-serif"}
            >
              <Link
                href="#media"
                underline="none"
                sx={{
                  color: "#555",
                  cursor: "pointer",
                  "&:hover": { textDecoration: "underline" },
                }}
                fontFamily={"Montserrat, sans-serif"}
              >
                Media
              </Link>
              {/* /
              <Link
                href="#quotes"
                underline="none"
                sx={{
                  color: "#555",
                  cursor: "pointer",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                Quotes
              </Link> */}
              /{" "}
              <Link
                href="#events"
                underline="none"
                sx={{
                  color: "#555",
                  cursor: "pointer",
                  "&:hover": { textDecoration: "underline" },
                }}
                fontFamily={"Montserrat, sans-serif"}
              >
                Events
              </Link>
              /{" "}
              <Link
                href="#credits"
                underline="none"
                sx={{
                  color: "#555",
                  cursor: "pointer",
                  "&:hover": { textDecoration: "underline" },
                }}
                fontFamily={"Montserrat, sans-serif"}
              >
                Credits
              </Link>
            </Typography>
            {/* Featured Movie Section */}
            <Typography
              variant="h4"
              component="div"
              id="media"
              sx={{
                marginBottom: 2,
                maxWidth: 800,
                // alignSelf: "center",
                // justifySelf: "center",
                marginLeft: "auto",
                marginRight: "auto",
                width: "100%",
                fontSize: "1.5em",
                fontWeight: "bold",
                color: "#555",
              }}
              fontFamily={"Montserrat, sans-serif"}
            >
              Media
            </Typography>
            <Grid
              maxWidth={800}
              minWidth={280}
              style={{
                marginRight: 10,
                marginLeft: 10,
                // marginBottom: 20,
              }}
            >
              <MovieCard />
            </Grid>
          </Grid>
        </Box>

        {/* Quotes Section */}
        {/* <Divider sx={{ marginY: 3 }} />
        <Typography
          variant="h4"
          component="div"
          sx={{
            marginBottom: 0,
            maxWidth: 800,
            alignSelf: "center",
            justifySelf: "center",
            marginLeft: "auto",
            marginRight: "auto",
            fontSize: "1.5em",
            fontWeight: "bold",
            color: "#555",
            // marginLeft:10
          }}
          id="quotes"
        >
          Quotes
        </Typography>
        <TestimonialsCard /> */}

        {/* Events Section */}
        <Divider sx={{ marginY: 3 }} />
        {/* <Typography
          variant="h4"
          component="div"
          sx={{
            marginBottom: 2,
            maxWidth: 800,
            // alignSelf: "center",
            // justifySelf: "center",
            marginLeft: "auto",
            marginRight: "auto",
            width: "100%",
          }}
        >
          Events
        </Typography> */}
        <div id="events"></div>
        <EventsAndFestivalsCard />

        {/* Credits Section */}
        <Divider sx={{ marginY: 3 }} />
        <Typography
          variant="h4"
          component="div"
          sx={{
            marginBottom: 2,
            maxWidth: 800,
            // alignSelf: "center",
            // justifySelf: "center",
            marginLeft: "auto",
            marginRight: "auto",
            width: "100%",
            fontSize: "1.5em",
            fontWeight: "bold",
            color: "#555",
          }}
          id="credits"
          fontFamily={"Montserrat, sans-serif"}
        >
          Credits
        </Typography>
        <CreditsCard2 />
        {/* <TrainingCard /> */}

        {/* Additional Education Section */}
        <Divider sx={{ marginY: 3 }} />
        {/* <Typography
          variant="h4"
          component="div"
          sx={{ marginBottom: 2, textAlign: "center" }}
        >
          Additional Education
        </Typography> */}
        {/* <AdditionalEducation /> */}
      </GradientWrapper>

      <Footer />
    </>
  );
};

export default Testimonials;
function MovieCard() {
  return (
    <>
      {/* Card for L'Inverno from Budapest Reporter */}
      <Card sx={{ boxShadow: 3, marginBottom: 2 }}>
        <CardContent sx={{ display: "flex", flexDirection: "column" }}>
          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{
              fontSize: "1.3em",
              fontWeight: "bold",
              color: "#555",
            }}
            fontFamily={"Montserrat, sans-serif"}
          >
            L’Inverno
          </Typography>
          <Typography
            variant="body2"
            paragraph
            fontFamily={"Montserrat, sans-serif"}
          >
            Budapest Reporter{" "}
            <a
              style={{
                textDecoration: "none",
                color: "black",
              }}
              href="https://www.budapestreporter.com/linverno-to-bring-wwii-era-forbidden-love-to-the-cinemas/"
            >
              https://www.budapestreporter.com/linverno-to-bring-wwii-era-forbidden-love-to-the-cinemas/
            </a>
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ marginLeft: "auto", textAlign: "right" }}
            fontFamily={"Montserrat, sans-serif"}
          >
            - https://www.budapestreporter.com
          </Typography>
          {/* </CardContent> */}
          <Box sx={{ textAlign: "center", paddingBottom: 2 }}>
            <Button
              size="small"
              color="primary"
              href="https://www.budapestreporter.com/linverno-to-bring-wwii-era-forbidden-love-to-the-cinemas/"
              target="_blank"
              rel="noopener noreferrer"
              fontFamily={"Montserrat, sans-serif"}
            >
              Read More
            </Button>
          </Box>
          {/* </Card> */}
          {/* <Divider /> */}
          {/* <Card sx={{ boxShadow: 3 }}>
        <CardContent sx={{ display: "flex", flexDirection: "column" }}> */}
          {/* <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{
              fontSize: "1.3em",
              fontWeight: "bold",
              color: "#555",
            }}
          >
            L’Inverno
          </Typography> */}
          {/* <Typography variant="body2" paragraph>
            "L’Inverno is the first pic to emerge from APX’s new Music World
            Films & TV venture — a new division headed by Mathew Knowles
            (Beyoncé’s father), who sold his Music World Entertainment Group to
            APX last month. As part of the deal, the film and TV division of
            Knowles’ company has been merged with the studio."
          </Typography> */}
          <Typography
            variant="body2"
            paragraph
            fontFamily={"Montserrat, sans-serif"}
          >
            Variety Magazine{" "}
            <a
              style={{
                textDecoration: "none",
                color: "black",
              }}
              href="https://variety.com/2022/film/global/roland-joffe-olivier-martinez-inverno-apx-1235220982/"
            >
              https://variety.com/2022/film/global/roland-joffe-olivier-martinez-inverno-apx-1235220982/
            </a>
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ marginLeft: "auto", textAlign: "right" }}
            fontFamily={"Montserrat, sans-serif"}
          >
            - https://variety.com/
          </Typography>
        </CardContent>
        <Box sx={{ textAlign: "center", paddingBottom: 2 }}>
          <Button
            size="small"
            color="primary"
            href="https://variety.com/2022/film/global/roland-joffe-olivier-martinez-inverno-apx-1235220982/"
            target="_blank"
            rel="noopener noreferrer"
            fontFamily={"Montserrat, sans-serif"}
          >
            Read More
          </Button>
        </Box>
      </Card>
    </>
  );
}

function TrainingAndEducation() {
  return (
    <>
      <Typography variant="h6" color="textSecondary" gutterBottom>
        Training & Education
      </Typography>
      <Typography variant="body1" gutterBottom>
        Sharron Aubrey received her education and training in the performing
        arts at several renowned institutions, including the prestigious Royal
        Academy of Dramatic Arts (RADA), the National Institute of Dramatic Arts
        (NIDA), and Sun Studios for filmmaking and film grammar. She has also
        completed masterclasses with Bernard Hiller in Rome and Paris, and
        participated in on-camera masterclasses with Nancy Bishop and Catherine.
      </Typography>
    </>
  );
}

function AdditionalEducation() {
  return (
    <>
      <Card sx={{ maxWidth: 800, margin: "20px auto", boxShadow: 3 }}>
        <CardContent>
          <Typography
            variant="h6"
            sx={{
              marginBottom: 1,
              fontSize: "1.3em",
              fontWeight: "bold",
              color: "#555",
            }}
          >
            Additional Education
          </Typography>
          <Typography variant="body1" sx={{ marginTop: "10px" }}>
            Sharron has also explored various fields beyond the arts, including
            Humanities and Naturopathy. She holds a Master's degree in Education
            and Linguistics, which has expanded her understanding of human
            expression and the intricacies of communication, further enhancing
            her artistic abilities.
          </Typography>
        </CardContent>
      </Card>
    </>
  );
}
const TrainingCard = () => {
  return (
    <Card sx={{ maxWidth: 800, mx: "auto", boxShadow: 3, my: 3 }}>
      <CardContent>
        {/* Training Section */}
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            fontSize: "1.3em",
            fontWeight: "bold",
            color: "#555",
          }}
        >
          Training
        </Typography>
        <Typography variant="body1" paragraph>
          Sharron Aubrey has undergone extensive training in acting and
          filmmaking across various renowned institutions. In 2015, she mastered
          the fundamentals of Film Grammar at Sonavista Studio. Earlier, in
          2012, she immersed herself in Method Acting under the guidance of Eric
          Morris at No Acting Film Stage. She also participated in the On Camera
          Masterclass with director Catherine Jarvis in 2010. Her journey began
          in 2008 at the Rinhardt Seminar in Vienna, where she trained under
          Anna Hauer. In 2007, Sharron took part in an On Camera Masterclass
          with Nancy Bishop Casting in both Prague and Vienna, followed by
          intensive masterclasses in Rome and Paris with Bernard Hiller,
          representing the Bernard Hiller Acting Studio in Los Angeles. During
          the same year, she honed her improvisation skills in Vienna with Kathy
          Tanner. In 2006, she deepened her expertise at the National Institute
          of Dramatic Arts (NIDA) in Sydney, studying Studio Acting for Film &
          Theatre. She also studied Method Acting at Aperion Studio in Vienna
          that same year. Earlier in 2005, Sharron completed Shakespearean
          acting training at the prestigious Royal Academy of Dramatic Arts
          (RADA) in London.
        </Typography>
      </CardContent>
    </Card>
  );
};
// const CreditsCard3 = () => {
//   return (
//     <Card sx={{ maxWidth: 800, margin: "20px auto", boxShadow: 3 }}>
//       <CardContent>
//         {/* Header */}
//         {/* <Typography variant="h4" gutterBottom>
//           Sharron Aubrey
//         </Typography> */}

//         {/* Theatre Credits */}
//         <Typography
//           variant="h5"
//           gutterBottom
//           sx={{
//             marginBottom: 1,
//             fontSize: "1.3em",
//             fontWeight: "bold",
//             color: "#555",
//           }}
//         >
//           Theatre Credits
//         </Typography>
//         <Grid container spacing={2}>
//           <Grid item xs={12} sm={6}>
//             <ListItem>
//               <ListItemText
//                 primary="One of Us"
//                 secondary="World Premiere | Role: Production Development | Playwright: Ron Elisha"
//               />
//             </ListItem>
//             <Divider />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <ListItem>
//               <ListItemText
//                 primary="Vital Signs"
//                 secondary="Role: Lead | Theatre Drachengasse / Vienna Theatre Project"
//               />
//             </ListItem>
//             <Divider />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <ListItem>
//               <ListItemText
//                 primary="A Moment On the Lips"
//                 secondary="Role: Lead | Ensemble Theatre / Vienna Theatre Project"
//               />
//             </ListItem>
//             <Divider />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <ListItem>
//               <ListItemText
//                 primary="The Lovers The Outcasts"
//                 secondary="World Premiere | Role: Producer | Schloss Theatre Schönbrunn"
//               />
//             </ListItem>
//             <Divider />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <ListItem>
//               <ListItemText
//                 primary="Two Women & A Chair"
//                 secondary="Role: Lead | Divadlo Inspirace Prague / English Productions"
//               />
//             </ListItem>
//             <Divider />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <ListItem>
//               <ListItemText
//                 primary="The Vagina Monologues"
//                 secondary="Role: Performer | Kosmos Theatre / Vienna Theatre Project"
//               />
//             </ListItem>
//             <Divider />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <ListItem>
//               <ListItemText
//                 primary="Daylight Savings"
//                 secondary="Role: Lead | Theatre des Augenblicks"
//               />
//             </ListItem>
//             <Divider />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <ListItem>
//               <ListItemText
//                 primary="Woman Theatre / Night Showcase"
//                 secondary="Role: Performer | NIDA Parade Playhouse | Dir. Jennifer Hagan"
//               />
//             </ListItem>
//             <Divider />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <ListItem>
//               <ListItemText
//                 primary="Katherine / Showcase"
//                 secondary="Role: Katherine | RADA Vanbrugh Theatre | Dir. Andrew Visnevski"
//               />
//             </ListItem>
//             <Divider />
//           </Grid>
//         </Grid>

//         {/* Film Credits */}
//         <Typography
//           variant="h5"
//           gutterBottom
//           sx={{
//             marginBottom: 1,
//             fontSize: "1.3em",
//             fontWeight: "bold",
//             color: "#555",
//             marginTop: "20px",
//           }}
//         >
//           Film Credits
//         </Typography>
//         <Grid container spacing={2}>
//           <Grid item xs={12} sm={6}>
//             <ListItem>
//               <ListItemText
//                 primary="Sugar"
//                 secondary="Feature/Development | Roles: Producer, Screenwriter, Actor"
//               />
//             </ListItem>
//             <Divider />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <ListItem>
//               <ListItemText
//                 primary="L'Inverno"
//                 secondary="Feature | Roles: Producer, Screenwriter, Actor"
//               />
//             </ListItem>
//             <Divider />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <ListItem>
//               <ListItemText
//                 primary="Ausstieg Rechts"
//                 secondary="Role: Woman | Dir. Bernhard Wegner / Rupert Höller"
//               />
//             </ListItem>
//             <Divider />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <ListItem>
//               <ListItemText
//                 primary="Odyssey of an Empress"
//                 secondary="Feature | Roles: Script Consultant, Co-Producer | Dir. Stefan Harader"
//               />
//             </ListItem>
//             <Divider />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <ListItem>
//               <ListItemText
//                 primary="1938"
//                 secondary="Short | Role: Lead | Dir. Michael Fischer"
//               />
//             </ListItem>
//             <Divider />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <ListItem>
//               <ListItemText
//                 primary="Sin in Emotions"
//                 secondary="Feature | Role: Alexandra | Dir. Aizhan Tuganbayeva"
//               />
//             </ListItem>
//             <Divider />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <ListItem>
//               <ListItemText
//                 primary="Unseen"
//                 secondary="Short | Role: First Assistant Director | Dir. Phil Moran / FFAB UK"
//               />
//             </ListItem>
//             <Divider />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <ListItem>
//               <ListItemText
//                 primary="Spirale"
//                 secondary="Short | Role: Assistant Director | Dir. Phil Moran / FFAB UK"
//               />
//             </ListItem>
//             <Divider />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <ListItem>
//               <ListItemText
//                 primary="Bad Date"
//                 secondary="Short | Role: Susie | Dir. Phil Moran / FFAB UK"
//               />
//             </ListItem>
//             <Divider />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <ListItem>
//               <ListItemText
//                 primary="Biodiversity Action Plan"
//                 secondary="Corporate | Role: Lead | FFAB UK"
//               />
//             </ListItem>
//             <Divider />
//           </Grid>
//         </Grid>
//       </CardContent>
//     </Card>
//   );
// };
const CreditsCard2 = () => {
  return (
    <Card sx={{ maxWidth: 800, mx: "auto", boxShadow: 3, my: 3 }}>
      <CardContent>
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            fontSize: "1.3em",
            fontWeight: "bold",
            color: "#555",
            marginTop: "20px",
          }}
          fontFamily={"Montserrat, sans-serif"}
        >
          Film Credits
        </Typography>
        <Typography
          variant="body1"
          paragraph
          fontFamily={"Montserrat, sans-serif"}
        >
          Sharon's entry into the film industry is remarkable, her films bring
          highly anticipated and supported by seasoned professionals and world
          wide audiences. Sharron is the lead producer screenwriter and actor of
          Feature Film L'inverno, WWII drama Palme d'Or Oscar Nominated Director
          and award winning team numerous Oscars recipients, US Film Sugar, a
          drama including A-List Director and in discussion to Oscar winning
          talent. Sci-fi Feature Film Shepherdess, director attached, and
          production partners Disney Studios Sydney. Further films include
          Biopic Odyssey of an Empress, director interest and Thriller Soul,
          production partners in development. Sharron has also starred in
          notable key and lead roles, 1938 Director Michael Fisher, Sin in
          Emotion, a feature from Aizhan Tuganbayeva, and Bad Date from Director
          Phil Moran. Sharron has also served as First Assistant Director in
          Unseen and Spirale, further diversifying and expanding her film
          experience.
        </Typography>

        <Typography
          variant="h5"
          gutterBottom
          sx={{
            fontSize: "1.3em",
            fontWeight: "bold",
            color: "#555",
          }}
          fontFamily={"Montserrat, sans-serif"}
        >
          Training
        </Typography>
        <Typography
          variant="body1"
          paragraph
          fontFamily={"Montserrat, sans-serif"}
        >
          Sharron Aubrey is a classically trained actress and has undergone
          extensive acting and filmmaking training from various renowned and
          prestigious institutions including RADA Royal Academy of Dramatic Arts
          London, and NIDA National Institute of Dramatic Arts Sydney. On camera
          Masterclasses include Bernard Hiller Rome, Paris, from the Bernard
          Hiller Studio Los Angeles, Casting Director Nancy Bishop, Prague and
          Vienna, and via Director Catherine Jarvis. Sharrons further skills
          include studies of improvisation and various immersive method acting
          training. Sharron also has mastered Filmmaking Grammar Fundamentals
          via Sonvista Studio.
        </Typography>

        {/* Theatre Credits */}
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            fontSize: "1.3em",
            fontWeight: "bold",
            color: "#555",
          }}
          fontFamily={"Montserrat, sans-serif"}
        >
          Theatre Credits
        </Typography>
        <Typography
          variant="body1"
          paragraph
          fontFamily={"Montserrat, sans-serif"}
        >
          Sharron's notable and illustrious theatre credits includes lead roles
          in Vital Signs, where she captivated audiences at Theatre Drachengasse
          in Vienna, and A Moment On the Lips, delivering a gripping performance
          at the Ensemble Theatre. In addition to performing, she produced The
          Lovers The Outcasts, a world premiere held at the historic Schloss
          Theatre in Schönbrunn. Her portrayal in Two Women & A Chair at Divadlo
          Inspirace in Prague earned her critical praise, while her compelling
          performance in The Vagina Monologues at Kosmos Theatre cemented her
          reputation as a dynamic performer. Other notable roles include
          Daylight Savings, Woman Theatre / Night Showcase at NIDA Parade
          Playhouse, and Katherine / Showcase at the prestigious RADA Vanbrugh
          Theatre.
        </Typography>

        <Typography
          variant="h5"
          gutterBottom
          sx={{
            fontSize: "1.3em",
            fontWeight: "bold",
            color: "#555",
          }}
          fontFamily={"Montserrat, sans-serif"}
        >
          Education & Areas of Expertise
        </Typography>
        <Typography
          variant="body1"
          paragraph
          fontFamily={"Montserrat, sans-serif"}
        >
          Sharron, a true Renaissance woman, has also explored various fields
          apart from the arts, including academic arenas of the Humanities and
          Arts, Naturopathy, a Master’s in Education, and Linguistics. As a
          former University Professor, these experiences have expanded her
          understanding of the human experience and expression, further
          deepening and enhancing her artistic and creative abilities.
        </Typography>
        {/* Film Credits */}
      </CardContent>
    </Card>
  );
};

export const TestimonialsCard = () => {
  return (
    <Card sx={{ width: "100%", margin: "20px auto", boxShadow: 3 }}>
      <CardContent>
        {/* Header for L'Inverno */}
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            marginBottom: 1,
            fontSize: "1.3em",
            fontWeight: "bold",
            color: "#555",
          }}
          fontFamily={"Montserrat, sans-serif"}
        >
          L'Inverno Testimonials
        </Typography>

        {/* Testimonial No. 3 */}
        <Box sx={{ marginBottom: 2 }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              marginBottom: 1,
              fontSize: "1.1em",
              fontWeight: "bold",
              color: "#555",
            }}
            fontFamily={"Montserrat, sans-serif"}
          >
            Roland Joffé, Director of "The Killing Fields" and "The Mission"
          </Typography>
          <Typography
            fontFamily={"Montserrat, sans-serif"}
            variant="body1"
            gutterBottom
          >
            "The making of 'L'Inverno' has been an incredibly moving process.
            The film is a captivating and intense character-driven tale that's
            stirring and strikingly atmospheric. I have no doubt that it will be
            a compelling dramatic motion-picture experience. Roland, who has
            worked with some of the most astonishing actors of our time, is
            fearless of sensitive subject matters and knows how to deliver a
            compelling and emotionally intelligent story."
          </Typography>
          <Typography variant="caption" color="textSecondary">
            Screenwriter, Actor, Producer Sharron Aubrey from VARIETY
          </Typography>
        </Box>

        <Divider />

        {/* Award-winning writer Ron Elisha */}
        <Box sx={{ marginTop: 2, marginBottom: 2 }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              marginBottom: 1,
              fontSize: "1.1em",
              fontWeight: "bold",
              color: "#555",
            }}
            fontFamily={"Montserrat, sans-serif"}
          >
            Award-winning Writer Ron Elisha
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            fontFamily={"Montserrat, sans-serif"}
          >
            "'L'Inverno' is a finely wrought and profoundly moving story whose
            characters bring home to us the immediacy and almost eternal nature
            of the Holocaust's dilemmas."
          </Typography>
        </Box>

        <Divider />

        {/* Testimonial from Kim and Kathryn Klug */}
        <Box sx={{ marginTop: 2, marginBottom: 2 }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              marginBottom: 1,
              fontSize: "1.1em",
              fontWeight: "bold",
              color: "#555",
            }}
            fontFamily={"Montserrat, sans-serif"}
          >
            Kim and Kathryn Klug, Composers of Martin Scorsese's 'Silence'.
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            fontFamily={"Montserrat, sans-serif"}
          >
            "Kathryn and I have read your masterful 'L'Inverno' and both feel
            that it's the best script we've ever read, and also the most
            literary! The writing is so full of poetry and music. As musicians,
            we're hearing so many ways in which the music could support this
            astonishingly powerful story. With greatest admiration & respect."
          </Typography>
        </Box>

        <Divider />

        {/* Additional quote from Sharron Aubrey */}
        {/* <Box sx={{ marginTop: 2, marginBottom: 2 }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              marginBottom: 1,
              fontSize: "1.1em",
              fontWeight: "bold",
              color: "#555",
            }}
          >
            Sharron Aubrey, Screenwriter, Actor, Producer
          </Typography>
          <Typography variant="body1" gutterBottom>
            "The making of 'L'Inverno' has been an incredibly moving process.
            The film is a captivating and intense character-driven tale that's
            stirring and strikingly atmospheric. Roland, who has worked with
            some of the most astonishing actors of our time, is fearless of
            sensitive subject matters and knows how to deliver."
          </Typography>
        </Box> */}

        {/* Header for Sugar */}
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            marginBottom: 1,
            fontSize: "1.3em",
            fontWeight: "bold",
            color: "#555",
            marginTop: 1,
          }}
          fontFamily={"Montserrat, sans-serif"}
        >
          Sugar Testimonials
        </Typography>

        {/* DOP Petra Korner Quote */}
        <Box sx={{ marginBottom: 2 }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              marginBottom: 1,
              fontSize: "1.1em",
              fontWeight: "bold",
              color: "#555",
            }}
            fontFamily={"Montserrat, sans-serif"}
          >
            Petra Korner, Award Winning DOP WIF Honoree
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            fontFamily={"Montserrat, sans-serif"}
          >
            "'Sugar' tells a unique story with socially and historically
            relevant issues. It touches my sensibilities as it gives a voice to
            a female minority, both from a storytelling and creative standpoint.
            I believe I can contribute greatly to the enormous visual potential
            of the film."
          </Typography>
        </Box>

        <Divider />

        {/* APX Executive Producer Quote */}
        <Box sx={{ marginTop: 2, marginBottom: 2 }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              marginBottom: 1,
              fontSize: "1.1em",
              fontWeight: "bold",
              color: "#555",
            }}
            fontFamily={"Montserrat, sans-serif"}
          >
            Matthew Knowles, American Executive Producers
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            fontFamily={"Montserrat, sans-serif"}
          >
            "'L'Inverno' is an enthralling, timeless story that's universally
            appealing and relevant to today's audience. During a time of global
            challenges, this film expresses themes of overcoming adversities,
            hope, and the virtue of humanity."
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

function EventsAndFestivalsCard() {
  return (
    <Card sx={{ maxWidth: 800, margin: "20px auto", boxShadow: 3 }}>
      <CardContent>
        <Typography
          fontFamily={"Montserrat, sans-serif"}
          variant="h6"
          gutterBottom
          sx={{
            marginBottom: 1,
            fontSize: "1.5em",
            fontWeight: "bold",
            color: "#555",
          }}
        >
          Events and Festivals
        </Typography>

        <Typography
          variant="body1"
          gutterBottom
          fontFamily={"Montserrat, sans-serif"}
        >
          Festival de Cannes, Cannes Film Festival, Biennale Venice Film
          Festival Premiere, Viennale Vienna Film Festival Premiere, Sydney Film
          Festival Opening Gala Premiere, Jewish Film Festival Vienna Opening
          Premiere, Hollywood in Vienna Gala Concert Wiener Musikverein, Vienna
          Film Ball Rathaus Grand Ballroom, Hofburg Palace Ball, United Nations
          Ball Hofburg Palace, Austrian Film Awards, Film European Premiere 360
          Joseftheatre, World Film Premiere The Fox Gartenbaukino, Openings
          Exhibitions Georgia O'Keefe Kunstforum, Basquiat Albertina, Monet
          Albertina, Westlicht Photography Museum, World Press Photography
          Award, Heidi Horten Collection Leopold Museum, Kunsthistorisches
          Museum Vienna Cecily Brown, Yahuda Bacon Mathausen Memorial, Cultural
          Attache Embassy Invitations Vienna Australian Embassy & French
          Embassy.
        </Typography>

        <Typography
          variant="body1"
          sx={{ marginTop: "20px" }}
          fontFamily={"Montserrat, sans-serif"}
        >
          Based in Europe for 20+ years (Vienna, Austria), Sharron has travelled
          extensively to Italy, France, Greece, Austria, and notably to Czech
          Republic, United Kingdom, Croatia, Hungary, Spain, Portugal, Germany,
          New Zealand, Indonesia, and the USA.
        </Typography>
      </CardContent>
    </Card>
  );
}
